import { render, staticRenderFns } from "./VisitClaims.vue?vue&type=template&id=fc3ef1cc&scoped=true"
import script from "./VisitClaims.vue?vue&type=script&lang=js"
export * from "./VisitClaims.vue?vue&type=script&lang=js"
import style0 from "./VisitClaims.vue?vue&type=style&index=0&id=fc3ef1cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3ef1cc",
  null
  
)

export default component.exports